import React from 'react';
import { Paper, Box, Grid,  TextField, Button } from '@mui/material';

const ProfilePasForm = ({ formik }) => {
  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: 2,
        p: 2,
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={4}>
            <TextField
              margin="normal"
              required
              fullWidth
              name="currentPassword"
              label="현재 패스워드"
              type="password"
              id="currentPassword"
              autoComplete="currentPassword"
              value={formik.values.currentPassword}
              onChange={formik.handleChange}
              error={
                formik.touched.currentPassword &&
                Boolean(formik.errors.currentPassword)
              }
              helperText={
                formik.touched.currentPassword && formik.errors.currentPassword
              }
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              margin="normal"
              required
              fullWidth
              name="changedPassword"
              label="변경 패스워드"
              type="password"
              id="changedPassword"
              autoComplete="changedPassword"
              value={formik.values.changedPassword}
              onChange={formik.handleChange}
              error={
                formik.touched.changedPassword &&
                Boolean(formik.errors.changedPassword)
              }
              helperText={
                formik.touched.changedPassword && formik.errors.changedPassword
              }
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              margin="normal"
              required
              fullWidth
              name="changedConfirmPassword"
              label="변경 패스워드 확인"
              type="password"
              id="changedConfirmPassword"
              autoComplete="changedConfirmPassword"
              value={formik.values.changedConfirmPassword}
              onChange={formik.handleChange}
              error={
                formik.touched.changedConfirmPassword &&
                Boolean(formik.errors.changedConfirmPassword)
              }
              helperText={
                formik.touched.changedConfirmPassword &&
                formik.errors.changedConfirmPassword
              }
            />
          </Grid>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Button color="primary" variant="outlined" type="submit">
          변경
        </Button>
      </Box>
    </Box>
  );
};

export default ProfilePasForm;
